import type { PlatformErrorAreas } from "$root/api/error-reporting";
import type { DropdownMenuProps } from "@mdotm/shadcn/mdotm/components";
import { PageDownloadMenu } from "./PageDownloadMenu";
import { PageMoreActionsMenu } from "./PageMoreActionsMenu";

export function PageDownloadAndMoreActionsMenu(props: {
	downloadActions?: DropdownMenuProps["actions"];
	moreActions?: DropdownMenuProps["actions"];
	area: PlatformErrorAreas;
}): React.JSX.Element {
	return (
		<div className="flex items-center gap-3">
			{Boolean(props.downloadActions?.length) && (
				<PageDownloadMenu area={props.area} actions={props.downloadActions!} />
			)}
			{Boolean(props.moreActions?.length) && <PageMoreActionsMenu area={props.area} actions={props.moreActions!} />}
		</div>
	);
}
